'use client';

import { forwardRef } from 'react';
import { Dialog as BaseOverlay, useDialogStore } from '@ariakit/react';
import clsx from 'clsx';

import styles from './DallasDialog.module.scss';
import DallasCard, { Props as DallasCardProps } from '../Card/DallasCard';
import DallasIconButtonClose from '../Buttons/DallasIconButton/DallasIconButtonClose';

export interface Props extends DallasCardProps {
  className?: string;
  onClose?: () => void;
  portal?: boolean;
  modal?: boolean;
}

const DallasDialog = forwardRef<HTMLDivElement, Props>(function DallasDialog(
  {
    className,
    onClose,
    header,
    modal = true,
    portal = true,
    ...cardProps
  }: Props,
  ref,
) {
  const dialogStore = useDialogStore({
    open: true,
    setOpen: (open) => !open && onClose?.(),
  });

  return (
    <BaseOverlay
      className={clsx(className, styles.root)}
      store={dialogStore}
      ref={ref}
      modal={modal}
      portal={portal}
      backdrop={<div className={styles.backdrop} />}
    >
      <DallasCard
        {...cardProps}
        className={styles.card}
        header={
          <>
            {header}
            {onClose && (
              <DallasIconButtonClose
                className={styles.closeButton}
                onClick={onClose}
                aria-label="Close"
                size="tiny"
                rounded
              />
            )}
          </>
        }
      />
    </BaseOverlay>
  );
});

export default DallasDialog;
